import PropTypes from 'prop-types'
import React, { useRef } from 'react'
import { withI18next } from 'lib/i18n/withI18next'
import ImageCarouselAutoPlayVideo from 'components/pdp/carousel-images/image-carousel/image-carousel-auto-play-video/ImageCarouselAutoPlayVideo'
import Typo from 'constants/typography'
import Icon, { ICONS, ICON_SIZE } from 'components/common/icon'
import { hasLocizeTranslation } from 'lib/utils/locize'
import Button from 'components/common/button'
import { BUTTON_TYPES } from 'constants/button'
import styles from './virtual-try-on-onboarding.scss'

const instructions = [
  { key: 'TRY_ON_SUGGESTION_1', defaultValue: 'Full body shot' },
  { key: 'TRY_ON_SUGGESTION_2', defaultValue: 'Good lighting' },
  { key: 'TRY_ON_SUGGESTION_3', defaultValue: 'Fitted clothes' },
  { key: 'TRY_ON_SUGGESTION_4', defaultValue: 'Hands out of pockets' },
]

const VirtualTryOnOnboarding = ({ t, isPhone, closeButton, onUploadImage }) => {
  const imageFileInputRef = useRef(null)
  const isTablet =
    typeof window !== 'undefined' &&
    window.innerWidth >= 300 &&
    window.innerWidth <= 1024
  return (
    <React.Fragment>
      <style jsx>{styles}</style>
      {closeButton && isPhone && closeButton}
      <div className="virtual-try-on-onboarding">
        <div className="virtual-try-on-onboarding__video-wrapper">
          <ImageCarouselAutoPlayVideo
            loop
            autoPlay
            poster="full_video_cover_url"
            className="virtual-try-on-onboarding__video"
            src="https://d3vhkxmeglg6u9.cloudfront.net/videos/FINAL+SLIDE+1-1.mp4"
          />
        </div>
        <div className="virtual-try-on-onboarding__info">
          <div className="virtual-try-on-onboarding__info__title">
            <span className={Typo.title2}>
              {hasLocizeTranslation(t, 'TRY_IT_ON', 'Try It On')}
            </span>
            {closeButton && !isPhone && closeButton}
          </div>
          <span className={Typo.body1}>
            {hasLocizeTranslation(
              t,
              'TRY_IT_ON_ONBOARDING_TITLE',
              'Try on 1,000s of Pomelo. styles without the hassle!',
            )}
          </span>
          <span className={Typo.body1}>
            {hasLocizeTranslation(
              t,
              'TRY_IT_ON_ONBOARDING_SUB_TITLE',
              'All you have to do is upload 1 photo of yourself',
            )}
          </span>
          <div className="virtual-try-on-onboarding__instruction-list">
            {instructions.map((pair) => (
              <div
                key={pair.key}
                className="virtual-try-on-onboarding__instruction-list__instruction"
              >
                <Icon
                  size={ICON_SIZE.medium}
                  src={ICONS.checkCircleActive}
                  alt="check circle active icon"
                />
                <span className={Typo.body2}>
                  {hasLocizeTranslation(t, pair.key, pair.defaultValue)}
                </span>
              </div>
            ))}
          </div>
          <div className="virtual-try-on-upload-image">
            <label
              htmlFor="custom-upload"
              className="virtual-try-on-upload-image__custom-upload-button"
            >
              {t('UPLOAD', 'Upload')}
              {isTablet && (
                <input
                  type="file"
                  id="custom-upload"
                  ref={imageFileInputRef}
                  accept=".jpg, .jpeg, .png"
                  onChange={(event) => {
                    onUploadImage(event.target.files[0])
                  }}
                  className="virtual-try-on-upload-image__hidden-file-input"
                />
              )}
            </label>
            {!isTablet && (
              <input
                type="file"
                id="custom-upload"
                ref={imageFileInputRef}
                accept=".jpg, .jpeg, .png"
                onChange={(event) => {
                  onUploadImage(event.target.files[0])
                }}
                className="virtual-try-on-upload-image__hidden-file-input"
              />
            )}
            <a
              style={{ textAlign: 'center' }}
              target="_blank"
              href="/info/terms-and-conditions"
            >
              <Button type={BUTTON_TYPES.link}>
                {hasLocizeTranslation(
                  t,
                  'TERMS_AND_CONDITIONS',
                  'TERMS AND CONDITIONS',
                )}
              </Button>
            </a>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

VirtualTryOnOnboarding.defaultProps = {
  isPhone: false,
}

VirtualTryOnOnboarding.propTypes = {
  isPhone: PropTypes.bool,
  t: PropTypes.func.isRequired,
  closeButton: PropTypes.node.isRequired,
  onUploadImage: PropTypes.func.isRequired,
  // productId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  //   .isRequired,
}

export default withI18next()(VirtualTryOnOnboarding)
